import React from 'react';
import {connect} from 'react-redux';
import {Dimmer, Loader} from 'semantic-ui-react';
import _ from 'lodash';
import REST from 'go/requests/rest';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {ContentDispatch} from 'framework';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';
import {isFemaUser, countDependenciesToLoad} from 'common/utils';
import {APPLICATION_DETAILS} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {SESSION_INFORMATION} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
export class PanelAdminContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSection: 'Session Overview',
    };
  }

  componentDidMount() {
    let {sessionId, configType, entityId} = this.props;
    document.title = entityId ? APPLICATION_DETAILS : SESSION_INFORMATION;

    this.setState({
      loading: true,
      error: false,
      redirect: false,
    });

    if (sessionId) {
      this.fetchSessionConfig(sessionId, configType)
        .then((config) => {
          this.initializeReduxState(config);
        })
        .catch((err) => {
          this.setState({
            error: true,
          });
        });
    } else {
      this.setState({
        error: true,
      });
    }
  }

  componentWillUnmount() {
    this.props.clear();
  }

  static getDerivedStateFromProps(props, state) {
    const dependencies = _.get(props, 'config.payload.dependencies');
    const toggles = _.get(props, 'toggles.toggles');
    const dependenciesToLoad = countDependenciesToLoad(
      dependencies,
      isFemaUser(_.get(state, 'auth.permissions')),
      toggles,
      'fundingOpportunityId',
      _.get(props, 'fundingOpportunityId')
    );
    if (
      state.initialized &&
      state.loading &&
      props.numLoadedSuccessfully === dependenciesToLoad
    ) {
      return {
        ...state,
        loading: false,
      };
    }
    return null;
  }

  fetchSessionConfig = (panelSessionId, taskDefKey) => {
    const {token} = this.props;
    return REST.panelReviewV2
      .getPanelSessionConfiguration(token, panelSessionId, taskDefKey)
      .then(REST.handler.handleResponse);
  };

  initializeReduxState = (config) => {
    const {init, auth, toggles, profile, sessionId, entityId} = this.props;
    init({
      config,
      context: {
        auth,
        toggles,
        profile,
        sessionId,
        entityId,
      },
      validations: {},
    });
    this.setState({initialized: true});
  };

  render() {
    let {config, location} = this.props;
    let {error, redirect, loading, submitting} = this.state;
    const listeners = _.get(config, 'payload.listeners', []);
    const contents = _.get(config, 'payload.contents', []);

    return (
      <React.Fragment>
        {error && <Error />}
        {loading && <Loader active>Loading...</Loader>}
        {!loading && !error && !redirect && (
          <React.Fragment>
            {_.map(listeners, (listenerConfig, index) => (
              <ContentDispatch config={listenerConfig} key={index} />
            ))}
            {_.map(contents, (itemConfig, index) => (
              <ContentDispatch
                key={itemConfig.type + index}
                config={itemConfig}
                rootPath={'context.session.payload'}
                currentLocation={location}
              />
            ))}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({
  init: (initState) => dispatch(DynamicComponentActions.initWithState(initState)),
  clear: () => {
    return new Promise((resolve, reject) => {
      dispatch(DynamicComponentActions.clearDynamicComponent({}));
      resolve();
    });
  },
});

export const mapStateToProps = (state) => {
  const currentLocation = _.get(state, 'dynamicComponent.currentLocation');

  return {
    auth: state.auth,
    profile: state.profile,
    toggles: state.toggles,
    token: state.auth.token,
    location: currentLocation === '' ? 'contents[0]' : currentLocation,
    applicationData: _.get(state, 'dynamicComponent.context.applicationDynamicData'),
    fundingOpportunityId: _.get(
      state,
      'dynamicComponent.context.panelReviewSession.fundingOpportunityId'
    ),
    routerLocation: _.get(state, 'router.location.pathname'),
    config: _.get(state, 'dynamicComponent.config'),
    data: _.get(state, 'dynamicComponent.data'),
    userId: state.auth.userId,
    numLoadedSuccessfully: _.get(state, 'dynamicComponent.context.numLoadedSuccessfully'),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PanelAdminContainer);
